export const URL_CONTACT_US = 'https://yieldbird.com/contact-us'
